'use client';
import styled, { css } from 'styled-components';

const stretchToParent = css`
  width: 100%;
  max-width: 100%;

  & > * {
    width: 100%;
    max-width: 100%;
    box-sizing: border-box;
  }
`;

const isFullWidthMobile = ({ $fullWidth, $fullWidthMobile }) =>
  Boolean($fullWidth || $fullWidthMobile);

const isFullWidthDesktop = ({ $fullWidth, $fullWidthDesktop }) =>
  Boolean($fullWidth || $fullWidthDesktop);

/**
 * 20px left/right inset when sideMargin is on with full-width.
 */
const sideMarginInsets = css`
  padding-left: ${props => props.theme.spacing(5)};
  padding-right: ${props => props.theme.spacing(5)};
`;

const stretchToParentWithOptionalSideMargin = css`
  ${stretchToParent}
  ${props => props.$sideMargin && sideMarginInsets}
`;

export const StyledCtaShell = styled.div`
  box-sizing: border-box;
  background-color: transparent;
  ${props => props.theme.getFocusOutline()}

  ${props =>
    isFullWidthMobile(props)
      ? stretchToParentWithOptionalSideMargin
      : css`
          width: ${props.$defaultWidth || 'fit-content'};
          max-width: 100%;

          ${props.$defaultWidth &&
          css`
            & > * {
              width: 100%;
            }
          `}
        `}

  @media ${props => props.theme.tablet} {
    ${props =>
      isFullWidthDesktop(props)
        ? stretchToParentWithOptionalSideMargin
        : css`
            width: ${props.$defaultWidth || 'fit-content'};
            max-width: 100%;
            padding-left: 0;
            padding-right: 0;

            & > * {
              width: ${props.$defaultWidth ? '100%' : 'auto'};
            }
          `}
  }
`;
